import { FRAMEWORK } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 border-t border-charcoal-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="02" label="Leadership Philosophy" />

        <div className="mt-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1]">
              Creative thinking, <em className="italic text-copper-600">operational</em> discipline.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-base sm:text-lg leading-relaxed text-charcoal-600">
              With 14+ years across creative design, creative operations, content development,
              brand communication, digital content and production execution, I work at the
              intersection of creativity and structure — leading teams, coordinating stakeholders
              and vendors, and delivering quality-focused communication across marketing, product,
              e-commerce and institutional functions.
            </p>
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-charcoal-600">
              The result: business requirements translated into impactful creative communication —
              on brand, on time, and ready to publish.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FRAMEWORK.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08}>
              <div
                data-testid={`framework-card-${item.id}`}
                className="group h-full bg-surface-white border border-charcoal-900/10 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl hover:border-copper-600/30 transition-[transform,box-shadow,border-color] duration-300"
              >
                <h3 className="font-serif text-2xl text-charcoal-900">{item.title}</h3>
                <span className="mt-3 block h-px w-8 bg-copper-600/40 group-hover:w-16 transition-[width] duration-300" />
                <p className="mt-4 text-sm leading-relaxed text-charcoal-600">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
